export enum CobrandedPartnerName {
  Cigna = 'cigna',
}
export const COBRANDED_PARTNER_IDS: Record<CobrandedPartnerName, string> = {
  [CobrandedPartnerName.Cigna]: '004-CIG',
};

export const COBRANDED_PARTNERS: Record<
  string,
  { displayName: string; logo: string; tenant: string; icon?: string }
> = {
  '004-CIG': {
    displayName: 'cigna',
    logo: 'cigna',
    tenant: 'cigna',
  },
};
